import React from 'react';
import Icon from '../../../components/AppIcon';

const CalendarHeader = ({ currentMonth, onPreviousMonth, onNextMonth, canGoPrevious, canGoNext }) => {
  const monthNames = [
    'January', 'February', 'March', 'April', 'May', 'June',
    'July', 'August', 'September', 'October', 'November', 'December'
  ];

  return (
    <div className="flex items-center justify-between mb-6 md:mb-8">
      <button
        onClick={onPreviousMonth}
        disabled={!canGoPrevious}
        className={`p-2 md:p-3 rounded-lg transition-all duration-250 ease-elegant ${
          canGoPrevious
            ? 'text-primary hover:bg-primary/10 hover:scale-110 active:scale-95' :'text-muted-foreground opacity-40 cursor-not-allowed'
        }`}
        aria-label="Previous month"
      >
        <Icon name="ChevronLeft" size={24} />
      </button>
      <div className="text-center">
        <h2 className="font-heading font-semibold text-2xl md:text-3xl lg:text-4xl text-foreground">
          {monthNames?.[currentMonth?.getMonth()]} {currentMonth?.getFullYear()}
        </h2>
        <p className="text-sm md:text-base text-muted-foreground font-caption mt-1">
          Select your preferred date
        </p>
      </div>
      <button
        onClick={onNextMonth}
        disabled={!canGoNext}
        className={`p-2 md:p-3 rounded-lg transition-all duration-250 ease-elegant ${
          canGoNext
            ? 'text-primary hover:bg-primary/10 hover:scale-110 active:scale-95' :'text-muted-foreground opacity-40 cursor-not-allowed'
        }`}
        aria-label="Next month"
      >
        <Icon name="ChevronRight" size={24} />
      </button>
    </div>
  );
};

export default CalendarHeader;